import { Component, Input, OnChanges, SimpleChange } from '@angular/core';

type OnlineIndicatorStatus = 'online' | 'offline';
type OnlineIndicatorSize = 'mid' | 'large' | 'xlarge';

@Component({
  selector: 'fl-online-indicator',
  template: `
    <div class="Indicator"
      [attr.aria-label]="ariaLabel"
      [attr.data-status]="status"
      [attr.data-size]="size"
    ></div>
  `,
  styleUrls: ['./online-indicator.component.scss'],
})
export class OnlineIndicatorComponent implements OnChanges {
  ariaLabel: string;

  @Input() relatedUser: string;
  @Input() status: OnlineIndicatorStatus = 'offline';
  @Input() size: OnlineIndicatorSize = 'mid';

  private updateAriaLabel() {
    this.ariaLabel = `${this.relatedUser || 'User'} is ${this.status}.`;
  }

  ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if ('relatedUser' in changes || 'status' in changes) {
      this.updateAriaLabel();
    }
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/online-status/online-indicator/online-indicator.component.ts